import { Injectable } from '@angular/core';
import { SupabaseSelectQueryConfig } from '@examdojo/core/supabase';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from, map } from 'rxjs';
import { SourceListItemHttpModel } from './source.model';
@Injectable({ providedIn: 'root' })
export class SourceHttpService extends SupabaseBaseHttpService<'sources', 'question_bank'> {
  readonly schema = 'question_bank';
  readonly tableName = 'sources';
  override readonly storage_bucket = 'sources';

  fetchPaginatedListView(selectQueryConfig: SupabaseSelectQueryConfig = {}) {
    const query = this.supabase.createSelectQuery('public', 'admin_source_items_view', selectQueryConfig);

    return from(query).pipe(
      map(({ data, count }) => ({
        data: data as SourceListItemHttpModel[],
        totalCount: count!,
      })),
    );
  }
}
